export default "../css/bdb4c5c6c7698194f4ef078c0c9a8c13.ttf";